// extracted by mini-css-extract-plugin
module.exports = {"amount":"Input_amount__3Xqlv","active":"Input_active__11ZEI"};